angular.module("Main").filter("containsTermine", function () {

    function filter(input, ids, active) {
        var result = [];
        if (!_.isNil(ids) && _.isArray(ids) && active === false) {
            _.forEach(input, function (i) {
                var intersection = _.intersection(i.RIds, ids);
                if (intersection.length > 0) {
                    result.push(i);
                }
            });
        } else if (!_.isNil(ids) && _.isArray(ids) && active === true) {
            _.forEach(input, function (i) {
                var intersection = _.intersection(i.RIds, ids);
                if (ids.length === intersection.length) {
                    result.push(i);
                }
            });
        }
        return result;
    }

    return filter;
});